export const LSTORAGE_KEY = {
    CONTENTS_LIKE: 'CONTENTS_LIKE',
    TTS_VOICE: 'TTS_VOICE',
    LATEST_READ: 'LATEST_READ',
    SELECT_REGION: 'select.region',
    TOGGLE_NEXT: 'TOGGLE_NEXT'
};

export const SESSION_KEY = {
    ZSID: 'za_bm_sid',
};

export const COOKIE_KEY = {
    BM_GY: '_bm_gy',
    BM_USER: "_bm_user"
};
